export default "__VITE_ASSET__aZJdRcE2__"